// src/services/futuresPricesWS.js
let ws = null;
let connected = false;
let dispatchRef = null;
let want = new Set();     // الرموز التي نريد متابعتها حاليًا (uppercase)
let has = new Set();      // الرموز المشترَك فيها فعليًا
let reconnectAttempts = 0;
let heartbeatTimer = null;

const WS_URL = 'wss://fstream.binance.com/ws';

function send(msg) {
  try {
    if (connected && ws?.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify(msg));
    }
  } catch {}
}

function subscribeSymbols(symbols) {
  if (!symbols.length) return;
  const params = symbols.map((s) => `${s.toLowerCase()}@markPrice@1s`);
  send({ method: 'SUBSCRIBE', params, id: Date.now() });
  symbols.forEach((s) => has.add(s));
}

function unsubscribeSymbols(symbols) {
  if (!symbols.length) return;
  const params = symbols.map((s) => `${s.toLowerCase()}@markPrice@1s`);
  send({ method: 'UNSUBSCRIBE', params, id: Date.now() + 1 });
  symbols.forEach((s) => has.delete(s));
}

function diffSubscribes() {
  if (!connected) return;
  // نريد = want ، لدينا = has
  const toSub = [...want].filter((s) => !has.has(s));
  const toUnsub = [...has].filter((s) => !want.has(s));
  if (toUnsub.length) unsubscribeSymbols(toUnsub);
  if (toSub.length) subscribeSymbols(toSub);
}

function handleMessage(ev) {
  try {
    const msg = JSON.parse(ev.data);
    // رسالة حدث markPriceUpdate
    if (msg.e === 'markPriceUpdate' && msg.s && msg.p != null) {
      const symbol = String(msg.s).toUpperCase();
      const price = Number(msg.p);
      if (isFinite(price) && dispatchRef) {
        dispatchRef({ type: 'assets/updateCoinPrice', payload: { symbol, price } });
      }
    }
    // رسائل ردّ SUBSCRIBE/UNSUBSCRIBE تُتجاهل
  } catch {}
}

function setupHeartbeat() {
  clearInterval(heartbeatTimer);
  heartbeatTimer = setInterval(() => {
    // Binance WS لا يتطلب ping منا، لكن لو أردت keep-alive:
    // send({ method: 'PING' }); // ليس ضروريًا؛ نتركه خاملاً.
  }, 30000);
}

function connect() {
  if (ws) try { ws.close(); } catch {}
  ws = new WebSocket(WS_URL);

  ws.onopen = () => {
    connected = true;
    reconnectAttempts = 0;
    setupHeartbeat();
    // عند الاتصال: اشترك في كل ما نريده الآن
    diffSubscribes();
  };

  ws.onmessage = handleMessage;

  ws.onerror = () => {
    try { ws.close(); } catch {}
  };

  ws.onclose = () => {
    connected = false;
    clearInterval(heartbeatTimer);
    // إعادة محاولة بباك-أوف
    const delay = Math.min(1000 * Math.pow(2, reconnectAttempts++), 15000);
    setTimeout(connect, delay);
  };
}

export function startFuturesPriceSocket(dispatch) {
  dispatchRef = dispatch;
  connect();
}

export function ensurePriceSubscriptions(symbolsUppercase) {
  // حدّث المجموعة المطلوبة
  want = new Set(symbolsUppercase.map((s) => s.toUpperCase()));
  diffSubscribes();
}

export function stopFuturesPriceSocket() {
  try { ws && ws.close(); } catch {}
  ws = null;
  connected = false;
  dispatchRef = null;
  want = new Set();
  has = new Set();
  reconnectAttempts = 0;
  clearInterval(heartbeatTimer);
}
